module.exports = __webpack_public_path__ + "static/ao-ab50076851a00dbd94d36f19dc2812a7.png";